'use strict';
import login from '../login';
import util from '../util';
import index from '../pages/product/index';
import customModal from '..//modal';
import validator from '../validator';
import shipping from '../pages/checkout/shipping';
import inputField from '../addressForm/input-field';

function checkoutLogin() {
    $.ajaxSetup({
        type: 'GET',
        cache: false,
        error: () => {
            console.log('An error occurred while processing your request. Please try again later.');
        }
    });

    $(document).on('click', '.checkout-login', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const $this = $(e.currentTarget);
        const ajaxUrl = $this.attr('data-ajax-login');
        const isRedesign = $this.attr('data-redesign');

        const data = {
            scope: isRedesign ? 'redesign' : ''
        };

        $.ajax({
            url: ajaxUrl,
            data: data,
            success: (response) => {
                if (response && response.error === undefined && response.url === undefined) {
                    setupLoginModal(response);
                    initialShippingData();
                }
            }
        });
    });
}

function setupLoginModal(response) {
    customModal.createCustomModal('login-modal', '#modal-custom-placeholder');
    const $loginModal = $('.login-modal');
    if ($loginModal.length && $loginModal.find('.modal-body').length) {
        const $modalBody = $loginModal.find('.modal-body');
        $modalBody.html(response);
        util.bodyPositionFixed('login-modal');
        validator.initForm('.login-modal form[id$="dwfrm_login"]');
        login.wishlistAjaxLogin('form[id$="dwfrm_login"]');
        $modalBody.scrollBox();
        if (isMacPlatform()) {
            $modalBody.find('.sb-content').addClass('padding-correction');
        }
    }
}

function isMacPlatform() {
    return /Mac|iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

function initialShippingData() {
    $('.shipping-login-modal').off().on('click', '#login', (e) => {
        e.preventDefault();
        e.stopPropagation();
        $('.ajax-loader').show();
        const $form = $('.shipping-login-modal form#dwfrm_login');
        const action = $form[0].action;
        const formData = `${$form.serialize()}&format=ajax&${$(e.currentTarget).attr('name')}=${$(e.currentTarget).val()}&isRedesign=true`;
        
        performAjaxLogin(action, formData);
    });
}

function performAjaxLogin(action, formData) {
    $.ajaxSetup({
        type: 'POST',
        dataType: 'json'
    });
      
    $.ajax({
        url: action,
        data: formData,
        success: function (data) {
            const ERROR_PASSWORD_EXPIRED = 'ERROR_PASSWORD_EXPIRED';
            const $shippingLoginModal = $('.shipping-login-modal');

            if(data.errorCode === ERROR_PASSWORD_EXPIRED){
                $shippingLoginModal.find('.error-form.password-expiry').removeClass('visually-hidden');
            } else if(data.success == 'fail'){
                $shippingLoginModal.find('.error-form').removeClass('visually-hidden');
            } else {
                $('.checkout-main-wrapper').html(data);		            
                $('#login-modal').find('.modal-close').trigger('click');
                window.User.isCustomerAuthenticated = true;
                $(document).trigger('loginDataChanged');
            }          
        },
        complete: function(){
            shipping.init(true);
            $('.ajax-loader').hide();
            $('.username').addClass('focus-in');
            const $nationalIDInput = $('.nationalIDNumber .input-text');
            const $billingAddress = $('.select-billing-address');
            if($nationalIDInput.val() !== '') {
                $nationalIDInput.closest('.material-input').addClass('focus-in');
            }
            validator.initForm('.checkout-shipping.address');
            inputField.setEditMaterialFields('.checkout-shipping .material-input .input-text');
            $nationalIDInput.on('focus', function () {
                $(this).on('blur', function (e) {
                    validator.initNationalIdnumber();
                });
            });
            if($billingAddress.find('.postal.error').length){
                $billingAddress.find('.phonenumber').trigger('blur')
            }
        },
        error: function (data) {
            console.log('error '+data);
        }
    });
}

var redesignCheckoutLogin = {
    /**
   * @function
   * @description method to init checkoutLogin
   */

    init: function () {
        checkoutLogin();
        initialShippingData();    
    }
};

export default redesignCheckoutLogin;
